import { connect } from 'react-redux';
import Training from '../../components/training/Training';

const mapStateToProps = () => ({
});

const mapDispatchToProps = () => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(Training);
